import React from 'react';
import { Row, Anchor, Col, Typography, Space, Card, Divider, Tag } from 'antd';
import { 
    DatabaseOutlined, 
    SafetyCertificateOutlined, 
    FileProtectOutlined, 
    ReadOutlined, 
    AuditOutlined,
    LockOutlined,
    ArrowRightOutlined
} from '@ant-design/icons';
import GsrdWch from '../../components/GsrdWch';

const { Title, Paragraph, Text } = Typography;

export default function DataAccess() {
    return (
        <div className="shared-hero-page" style={{ backgroundColor: '#f9fbff', minHeight: '100vh', paddingBottom: '100px' }}>
            {/* Hero Section */}
            <div className="shared-hero-banner" style={{
                padding: '100px 0 140px',
                textAlign: 'center',
                color: 'white',
                marginBottom: '-80px'
            }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                    <Title level={1} style={{ color: 'white', fontSize: '48px', fontWeight: 800, marginBottom: '16px' }}>
                        Data Access
                    </Title>
                </div>
            </div>

            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                <Row gutter={40}>
                    {/* Sticky Sidebar */}
                    <Col xs={24} md={6}>
                        <div style={{ position: 'sticky', top: '100px', zIndex: 10 }}>
                            <Card 
                                bordered={false} 
                                style={{ 
                                    borderRadius: '16px', 
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.05)',
                                    background: '#ffffff'
                                }}
                                bodyStyle={{ padding: '24px 16px' }}
                            >
                                <Title level={5} style={{ paddingLeft: '16px', marginBottom: '20px', color: '#055878', letterSpacing: '1px' }}>
                                    CONTENTS
                                </Title>
                                <Anchor
                                    offsetTop={100}
                                    items={[
                                        {
                                            key: 'part-1',
                                            href: '#part-1',
                                            title: <span style={{ fontSize: '14px', fontWeight: 500 }}>1. Access Classification</span>,
                                        },
                                        {
                                            key: 'part-2',
                                            href: '#part-2',
                                            title: <span style={{ fontSize: '14px', fontWeight: 500 }}>&nbsp;&nbsp;• Detailed Breakdown</span>,
                                        },
                                        {
                                            key: 'part-3',
                                            href: '#part-3',
                                            title: <span style={{ fontSize: '14px', fontWeight: 500 }}>2. Requirements</span>,
                                        },
                                        {
                                            key: 'part-4',
                                            href: '#part-4',
                                            title: <span style={{ fontSize: '14px', fontWeight: 500 }}>3. Usage Terms</span>,
                                        },
                                        {
                                            key: 'part-5',
                                            href: '#part-5',
                                            title: <span style={{ fontSize: '14px', fontWeight: 500 }}>4. Confidentiality</span>,
                                        },
                                        {
                                            key: 'part-6',
                                            href: '#part-6',
                                            title: <span style={{ fontSize: '14px', fontWeight: 500 }}>5. Safeguards</span>,
                                        },
                                    ]}
                                />
                            </Card>
                        </div>
                    </Col>

                    {/* Main Content */}
                    <Col xs={24} md={18}>
                        <Space direction="vertical" size={40} style={{ width: '100%' }}>
                            
                            {/* Section 1 */}
                            <Card id="part-1" bordered={false} style={{ borderRadius: '24px', boxShadow: '0 10px 30px rgba(0,0,0,0.06)' }} bodyStyle={{ padding: '48px' }}>
                                <Title level={2} style={{ fontWeight: 800, color: '#055878', marginBottom: '32px', display: 'flex', alignItems: 'center' }}>
                                    <DatabaseOutlined style={{ marginRight: '16px', color: '#13769a' }} />
                                    1.Access Classification and User Roles
                                </Title>
                                <Paragraph style={{ fontSize: '17px', lineHeight: '1.8', color: '#444', marginBottom: '32px' }}>
                                    To ensure the appropriate use and security of data, the <GsrdWch /> project provides three categories of data access based on user qualifications:
                                </Paragraph>
                                
                                <Row gutter={[24, 24]}>
                                    <Col xs={24} md={8}>
                                        <div style={{ padding: '24px', background: '#f6ffed', borderRadius: '16px', height: '100%', border: '1px solid #b7eb8f', boxShadow: '0 4px 12px rgba(82, 196, 26, 0.05)' }}>
                                            <Tag color="success" style={{ marginBottom: '12px', borderRadius: '4px' }}>PUBLIC</Tag>
                                            <Title level={4} style={{ margin: '0 0 12px', color: '#135200' }}>Public Access</Title>
                                            <Text style={{ fontSize: '14px', color: '#237804' }}>Free access to open data resources and project overview.</Text>
                                        </div>
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <div style={{ padding: '24px', background: '#e6f7ff', borderRadius: '16px', height: '100%', border: '1px solid #91d5ff', boxShadow: '0 4px 12px rgba(24, 144, 255, 0.05)' }}>
                                            <Tag color="processing" style={{ marginBottom: '12px', borderRadius: '4px' }}>REGISTERED</Tag>
                                            <Title level={4} style={{ margin: '0 0 12px', color: '#003a8c' }}>Registered Access</Title>
                                            <Text style={{ fontSize: '14px', color: '#0050b3' }}>For verified researchers, requires real-name registration and institutional affiliation.</Text>
                                        </div>
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <div style={{ padding: '24px', background: '#fff7e6', borderRadius: '16px', height: '100%', border: '1px solid #ffd591', boxShadow: '0 4px 12px rgba(250, 140, 22, 0.05)' }}>
                                            <Tag color="warning" style={{ marginBottom: '12px', borderRadius: '4px' }}>RESTRICTED</Tag>
                                            <Title level={4} style={{ margin: '0 0 12px', color: '#873800' }}>Restricted Access</Title>
                                            <Text style={{ fontSize: '14px', color: '#ad4e00' }}>For authorized partner researchers, requires ethics approval and collaboration agreement.</Text>
                                        </div>
                                    </Col>
                                </Row>

                                <Divider style={{ margin: '48px 0' }} />

                                <div id="part-2">
                                    <Title level={3} style={{ fontWeight: 800, marginBottom: '32px', color: '#055878' }}>
                                        <SafetyCertificateOutlined style={{ marginRight: '12px', color: '#13769a' }} />
                                        Expanded Data Access Classification
                                    </Title>
                                    
                                    <Paragraph style={{ fontSize: '16px', lineHeight: '1.8', color: '#555' }}>
                                        Each data access level corresponds to the nature of the data and the user's credentials:
                                    </Paragraph>

                                    <div style={{ marginTop: '24px' }}>
                                        <div style={{ marginBottom: '32px', paddingLeft: '20px', borderLeft: '3px solid #52c41a' }}>
                                            <Title level={5} style={{ color: '#135200', marginBottom: '8px' }}>Public Access:</Title>
                                            <Paragraph style={{ color: '#444' }}>
                                                • Includes open datasets, variant frequency summaries, phenotypic overviews.<br />
                                                • No login or registration required.<br />
                                                • Suitable for general education, public health outreach, and awareness initiatives.
                                            </Paragraph>
                                        </div>
                                        
                                        <div style={{ marginBottom: '32px', paddingLeft: '20px', borderLeft: '3px solid #1890ff' }}>
                                            <Title level={5} style={{ color: '#003a8c', marginBottom: '8px' }}>Registered Access:</Title>
                                            <Paragraph style={{ color: '#444' }}>
                                                • Access to basic curated datasets after institutional verification.<br />
                                                • Phenotype classifications, disease spectrum summaries, population-level statistics.<br />
                                                • Requires real-name authentication and institutional email domain registration.<br />
                                                • Data is strictly de-identified and aggregated.
                                            </Paragraph>
                                        </div>
                                        
                                        <div style={{ paddingLeft: '20px', borderLeft: '3px solid #fa8c16' }}>
                                            <Title level={5} style={{ color: '#873800', marginBottom: '8px' }}>Restricted Access:</Title>
                                            <Paragraph style={{ color: '#444' }}>
                                                • Access to raw sequencing data (FASTQ, BAM), VCF files, individual-level de-identified clinical metadata.<br />
                                                • Requires signed collaboration agreement, IRB approval, ethics board clearance.<br />
                                                • Bound by full legal, ethical, and institutional compliance.
                                            </Paragraph>
                                        </div>
                                    </div>
                                </div>
                            </Card>

                            {/* Section 2 */}
                            <Card id="part-3" bordered={false} style={{ borderRadius: '24px', boxShadow: '0 10px 30px rgba(0,0,0,0.06)' }} bodyStyle={{ padding: '48px' }}>
                                <Title level={2} style={{ fontWeight: 800, color: '#055878', marginBottom: '32px', display: 'flex', alignItems: 'center' }}>
                                    <FileProtectOutlined style={{ marginRight: '16px', color: '#13769a' }} />
                                    2. Application & Registration Requirements
                                </Title>
                                <div style={{ padding: '32px', background: '#f0f5ff', borderRadius: '16px', border: '1px dashed #adc6ff' }}>
                                    <Paragraph style={{ fontSize: '17px', lineHeight: '1.8', color: '#444' }}>
                                        Users must register with real-name authentication. For restricted access, users must submit:
                                    </Paragraph>
                                    <ul style={{ fontSize: '16px', color: '#555', lineHeight: '2.2', marginTop: '16px' }}>
                                        <li style={{ listStyleType: 'square' }}>A research proposal</li>
                                        <li style={{ listStyleType: 'square' }}>Ethics/IRB approval</li>
                                        <li style={{ listStyleType: 'square' }}>A signed data use and confidentiality agreement</li>
                                        <li style={{ listStyleType: 'square' }}>Team roster and responsible PI declaration</li>
                                    </ul>
                                    <Divider style={{ margin: '24px 0' }} />
                                    <Paragraph style={{ fontWeight: 600, color: '#055878', display: 'flex', alignItems: 'center', marginBottom: 0 }}>
                                        <AuditOutlined style={{ marginRight: '8px' }} />
                                        Applications are reviewed by the <GsrdWch /> Data Access Committee (DAC).
                                    </Paragraph>
                                </div>
                            </Card>

                            {/* Section 3 */}
                            <Card id="part-4" bordered={false} style={{ borderRadius: '24px', boxShadow: '0 10px 30px rgba(0,0,0,0.06)' }} bodyStyle={{ padding: '48px' }}>
                                <Title level={2} style={{ fontWeight: 800, color: '#055878', marginBottom: '32px', display: 'flex', alignItems: 'center' }}>
                                    <ReadOutlined style={{ marginRight: '16px', color: '#13769a' }} />
                                    3. Data Usage Terms
                                </Title>
                                <Row gutter={24}>
                                    <Col xs={24} md={12}>
                                        <div style={{ padding: '24px', background: '#fafafa', borderRadius: '16px', height: '100%' }}>
                                            <Title level={5} style={{ color: '#055878' }}>Authorized Use Only</Title>
                                            <Paragraph style={{ color: '#666', fontSize: '15px', marginBottom: 0 }}>
                                                Shared data must only be used for the approved research purposes. Redistribution or unauthorized use is prohibited.
                                            </Paragraph>
                                        </div>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <div style={{ padding: '24px', background: '#fafafa', borderRadius: '16px', height: '100%' }}>
                                            <Title level={5} style={{ color: '#055878' }}>Modification Requests</Title>
                                            <Paragraph style={{ color: '#666', fontSize: '15px', marginBottom: 0 }}>
                                                Any changes to the project scope or personnel require prior approval.
                                            </Paragraph>
                                        </div>
                                    </Col>
                                </Row>
                            </Card>

                            {/* Section 4 & 5 */}
                            <Row gutter={24}>
                                <Col xs={24} lg={12}>
                                    <Card id="part-5" bordered={false} style={{ borderRadius: '24px', boxShadow: '0 10px 30px rgba(0,0,0,0.06)', height: '100%' }} bodyStyle={{ padding: '40px' }}>
                                        <Title level={3} style={{ fontWeight: 800, color: '#055878', marginBottom: '24px' }}>
                                            <SafetyCertificateOutlined style={{ marginRight: '12px', color: '#13769a' }} />
                                            4. Confidentiality and Data Protection
                                        </Title>
                                        <Paragraph style={{ fontSize: '15px', color: '#555', lineHeight: '1.8' }}>
                                            All users must protect patient privacy and avoid any attempts to re-identify individuals from genomic data.<br /><br />
                                            Data must be anonymized and stored/accessed securely.<br /><br />
                                            The obligation of confidentiality continues even after project completion.
                                        </Paragraph>
                                    </Card>
                                </Col>
                                <Col xs={24} lg={12}>
                                    <Card id="part-6" bordered={false} style={{ borderRadius: '24px', boxShadow: '0 10px 30px rgba(0,0,0,0.06)', height: '100%' }} bodyStyle={{ padding: '40px' }}>
                                        <Title level={3} style={{ fontWeight: 800, color: '#055878', marginBottom: '24px' }}>
                                            <LockOutlined style={{ marginRight: '12px', color: '#13769a' }} />
                                            5. Legal and Technical Safeguards
                                        </Title>
                                        <Paragraph style={{ fontSize: '15px', color: '#555', lineHeight: '1.8' }}>
                                            Access to raw sequencing files (e.g., FASTQ, BAM) requires additional approval and must go through a secure environment.<br /><br />
                                            Data logs and access behaviors will be monitored and audited.
                                        </Paragraph>
                                    </Card>
                                </Col>
                            </Row>

                            <div style={{ height: '60px' }} />
                        </Space>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

// Helper icons fix for ArrowRightOutlined
const ArrowRightRightOutlined = () => <ArrowRightOutlined style={{ fontSize: '14px', marginRight: '8px', color: '#13769a' }} />;
